import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Switch.scss';
import { SwitchTick } from './SwitchTick';
import { SIZE } from '../../constants';
export { SIZE };
export function Switch(props) {
    let className = '';
    className += props.isDisabled ? ' sg-switch-isDisabled' : '';
    return (_jsxs("label", { className: 'sg-switch' + className, title: props.tooltip, tabIndex: 0, "data-test-id": props.testId, children: [props.children && _jsx("span", { className: 'sg-switch--label', children: props.children }), _jsx("span", { className: 'sg-switch--tick', children: _jsx(SwitchTick, { name: props.name, value: props.value, size: props.size, isChecked: props.isChecked, isDisabled: props.isDisabled, onChange: props.onChange, testId: props.testId ? `${props.testId}-input` : undefined }) })] }));
}
//# sourceMappingURL=Switch.js.map